import { render, staticRenderFns } from "./GridCompBigNew.vue?vue&type=template&id=efe04a10&scoped=true"
import script from "./GridCompBigNew.vue?vue&type=script&lang=js"
export * from "./GridCompBigNew.vue?vue&type=script&lang=js"
import style0 from "./GridCompBigNew.vue?vue&type=style&index=0&id=efe04a10&prod&lang=stylus&scoped=true"
import style1 from "./GridCompBigNew.vue?vue&type=style&index=1&id=efe04a10&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe04a10",
  null
  
)

export default component.exports